import { Outlet, useLocation, useNavigate } from "react-router";
import { useEffect, useRef, useState } from "react";
import Header from "@/components/header/header";
import { EXCLUDE_BREADCRUMB_PATH, ADMIN_MY_INFO_CHANGE_PD_PATH } from "@/utils/global-constants";
import { checkAccessPermission } from "@/utils/access-control";
import { getUserRoleFromCookie, getPasswordChangeType } from "@/utils/cookie-utils";

export default function AdminHomeLayout() {
  const location = useLocation();
  const navigate = useNavigate();
  const path = location.pathname;
  const isHome = EXCLUDE_BREADCRUMB_PATH.includes(path);
  const previousPathRef = useRef<string | null>(null);
  const [isCheckingPermission, setIsCheckingPermission] = useState(true);
  const [hasPermission, setHasPermission] = useState(false);

  const breadcrumbHeight = `var(--header-height-no-breadcrumb)`;
  const breadcrumbHeightWithBreadcrumb = `var(--header-height-with-breadcrumb)`;

  useEffect(() => {
    const fetchUserRole = async () => {
      try {
        const userRole = await getUserRoleFromCookie();
        console.log("[AdminHomeLayout] :: 사용자 역할 조회", { path, userRole });

        if (!userRole) {
          navigate("/", { replace: true });
          return;
        }

        // 패스워드 변경이 필요한지 확인
        const passwordChangeRequired = getPasswordChangeType();

        // 패스워드 변경이 필요한 경우, 패스워드 변경 페이지가 아니면 리다이렉트
        if (passwordChangeRequired && path !== ADMIN_MY_INFO_CHANGE_PD_PATH) {
          console.log(
            `[AdminHomeLayout] 패스워드 변경이 필요하여 패스워드 변경 페이지로 리다이렉트합니다.`
          );
          navigate(ADMIN_MY_INFO_CHANGE_PD_PATH, { replace: true });
          return;
        }

        const accessControlResult = checkAccessPermission(userRole, path);
        console.log(`[AdminHomeLayout] path:`, path);
        console.log(`[AdminHomeLayout] userRole:`, userRole);
        console.log(`[AdminHomeLayout] :: 접근 권한 체크 결과:`, accessControlResult);

        if (!accessControlResult.hasAccess) {
          console.warn(`[AdminHomeLayout] :: 접근 권한 없음. /home으로 리다이렉트합니다.`);
          navigate("/home", { replace: true });
          return;
        }

        // 권한이 있는 경우에만 화면을 표시
        setHasPermission(true);
      } catch (error) {
        console.error(`[AdminHomeLayout] :: 사용자 역할 조회 중 오류:`, error);
        navigate("/", { replace: true });
        return;
      } finally {
        // 권한 체크 완료
        setIsCheckingPermission(false);
      }
    };
    fetchUserRole();

    // 현재 경로를 이전 경로로 저장
    previousPathRef.current = path;
  }, [path, navigate]);

  console.log(
    `[AdminHomeLayout] :: Breadcrumb 경로에 포함되어 헤더를 표시하지 않습니다. ${isHome} 이므로 페이지 top이 ${
      isHome ? breadcrumbHeight : breadcrumbHeightWithBreadcrumb
    } 이 됩니다.`
  );

  // 권한 체크 중이거나 권한이 없는 경우 로딩 화면 표시
  if (isCheckingPermission || !hasPermission) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          fontSize: "18px",
          color: "#666",
        }}
      />
    );
  }

  return (
    <div style={{ paddingTop: isHome ? breadcrumbHeight : breadcrumbHeightWithBreadcrumb }}>
      <Header />
      <main>
        <Outlet />
      </main>
    </div>
  );
}
